import { mpClickDocLink } from "./mixpanel";

export const appUtmParams = "?utm_source=intelligems_app";

type OpenNewTabOptions = {
  mixpanelTracker?: string;
  noUtmParams?: boolean;
  source?: string;
  docLinkUrl?: string;
};

export function openNewTab(link: string, options?: OpenNewTabOptions): void;
/**
 * @deprecated Pass an options object instead (see above overload signature)
 *
 * @example
 * // Old (deprecated):
 * openNewTab("https://example.com", "tracker_name", true);
 *
 * // New:
 * openNewTab("https://example.com", { mixpanelTracker: "tracker_name", noUtmParams: true });
 */
export function openNewTab(
  link: string,
  options?: string,
  noUtmParams?: boolean
): void;
export function openNewTab(
  link: string,
  options?: string | OpenNewTabOptions,
  noUtmParams?: boolean
) {
  const normalized: OpenNewTabOptions =
    typeof options === "string"
      ? { mixpanelTracker: options, noUtmParams }
      : (options ?? {});

  const url = new URL(link.startsWith("http") ? link : `https://${link}`);

  if (!normalized.noUtmParams) {
    url.searchParams.set("utm_source", "intelligems_app");
  }

  window.open(url.toString(), "_blank", "noopener noreferrer");

  if (normalized.mixpanelTracker) {
    mpClickDocLink(
      normalized.mixpanelTracker,
      normalized.source,
      false,
      normalized.docLinkUrl
    );
  }
}
